module.exports = __webpack_public_path__ + "img/png.b834b7df.svg";